import { selectGAPIAccounts } from '../gAPIAccountEntitySlice';
import { loadExternalAccountImage } from './imageLoadingService';

export const preloadExternalProductImages = (productIds: string[]): void => {
    const gapiAccounts = selectGAPIAccounts();

    productIds.forEach((productId) => {
        const gapiAccount = gapiAccounts.find((account) => account.productId === productId);

        if (gapiAccount?.hasImage) {
            loadExternalAccountImage(productId);
        }
    });
};
